import {
  Grid,
  Button,
  CircularProgress,
  useTheme,
  Typography,
} from '@mui/material';

const SubsidiaryActions = ({ onAutoSelect, onMapSelect, isLoading, name }) => {
  const theme = useTheme();

  return (
    <>
      {/* Botón "Más cercano" */}
      <Grid id="grid-item-closest" item xs={12} sm={6}>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={onAutoSelect}
          sx={{
            borderRadius: '8px',
            fontWeight: 600,
            height: '45px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            p: 0,
            '&:hover': { bgcolor: theme.primary, color: theme.text1 },
          }}
        >
          {isLoading ? (
            <CircularProgress
              size={40}
              sx={{
                color: '#FFF',
                transform: { xs: 'scale(0.5)', sm: 'scale(1)' },
              }}
            />
          ) : (
            <Typography
              sx={{
                fontSize: { xs: 16, md: 14, xl: 16 },
                width: '100%',
                textAlign: 'center',
                color: '#000',
              }}
            >
              {name} más cercano
            </Typography>
          )}
        </Button>
      </Grid>

      {/* Botón "Seleccionar en el mapa" */}
      <Grid item xs={12} sm={6}>
        <Button
          variant="outlined"
          fullWidth
          onClick={onMapSelect}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            p: 0,
            borderRadius: '8px',
            borderColor: 'primary.main',
            color: 'black',
            fontWeight: 600,
            height: '45px',
            '&:hover': {
              borderColor: 'tertiary.main',
              bgcolor: '#f5f5f5',
            },
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: 16, md: 14, xl: 16 },
              width: '100%',
              textAlign: 'center',
              color: '#000',
            }}
          >
            Seleccionar en el mapa
          </Typography>
        </Button>
      </Grid>
    </>
  );
};

export default SubsidiaryActions;
